export const FOOTER_BUTTON_TARGET_ID = "lp-form";
